import React, { useCallback } from 'react';
import {
  AppBar, Toolbar, createStyles, makeStyles, Theme,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import { setArticleFormsReset, setArticleFormsSubmit } from '../../../../store/modules/articles/actions';
import { selectArticleForms } from '../../../../store/modules/articles/selectors';
import FormReset from './FormReset';
import FormSubmit from './FormSubmit';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  panel: {
    backgroundColor: palette.background.default,
    height: '72px',
    top: 'auto',
    bottom: 0,
    justifyContent: 'center',
    flexDirection: 'row',
    zIndex: 2147483100,
  },
  toolbar: {
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: '960px',
  },
}), { name: 'ArticleFormAction' });

const FormAction = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const forms = useSelector(selectArticleForms);

  const isVisible = (): boolean => {
    if (forms.isReset || forms.isSubmit) {
      return false;
    }
    if (forms.forms) {
      return forms.forms.filter((item) => item.isChange).length > 0;
    }
    return false;
  };

  const isValid = (): boolean => {
    if (forms.forms) {
      return forms.forms.filter((item) => !item.isValid).length === 0;
    }
    return true;
  };

  const submit = useCallback(() => {
    dispatch(setArticleFormsSubmit(true));
  }, [dispatch]);

  const reset = useCallback(() => {
    dispatch(setArticleFormsReset(true));
  }, [dispatch]);

  if (!isVisible()) {
    return null;
  }

  return (
    <AppBar
      position="fixed"
      className={classes.panel}
    >
      <Toolbar className={classes.toolbar}>
        <FormReset reset={reset} />
        <FormSubmit submit={submit} isValid={isValid()} />
      </Toolbar>
    </AppBar>
  );
};

export default FormAction;
